const actions = {
   async fetchCalculationModels(_, {studyPeriodsIds}) {
      return (
         await this._vm.$http.post('/api/calculation', {
            studyPeriodsIds,
         })
      ).data;
   },

   async calculateModels(_, {models}) {
      return (await this._vm.$http.post('/api/calc_models', {models})).data;
   },

   async fetchCalcResults(_, {studyPeriodsIds}) {
      return (
         await this._vm.$http.post('/api/calc_results', {
            studyPeriodsIds,
         })
      ).data;
   },
};

export default {
   namespaced: true,
   actions,
};
